import {
  FETCH_ADMIN_LINKS,
  ADD_USER_LINK,
  FETCH_USER_LINKS,
  DELETE_USER_LINK,
  UPDATE_USER_LINK
} from './constants'

const initialState = {
  isFetching: false,
  adminLinks: [],
  customer: '',
  userLinks: []
}

export default function linksReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ADMIN_LINKS.REQUEST: {
      return {
        ...state,
        isFetching: true,
        customer: action.customer
      }
    }
    case FETCH_ADMIN_LINKS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        adminLinks: action.links
      }
    }
    case FETCH_USER_LINKS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_USER_LINKS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        userLinks: action.links
      }
    }
    case ADD_USER_LINK.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case ADD_USER_LINK.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        userLinks: action.links
      }
    }
    case UPDATE_USER_LINK.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case UPDATE_USER_LINK.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        userLinks: action.links
      }
    }
    case DELETE_USER_LINK.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case DELETE_USER_LINK.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        userLinks: action.links
      }
    }
    default: {
      return state
    }
  }
}
